import { normalizeId } from 'utils/ids';

import type { RichTreeItem } from '../../types';
import { getParentTreeId } from '../../utils/treeId';

export function findPathToNodeByDataNodeId(items: RichTreeItem[], dataNodeId: string): string[] | null {
  const normalId = normalizeId(dataNodeId);
  const path: string[] = [];

  function dfs(nodes: RichTreeItem[]): boolean {
    for (const item of nodes) {
      path.push(item.id);
      if (normalizeId(item.dataNodeId) === normalId) return true;
      if (item.children && dfs(item.children)) return true;
      path.pop();
    }
    return false;
  }

  return dfs(items) ? path : null;
}

export function isMoveTargetUnchanged(initialMoveNodeId: string, selectedParentId: string | null | undefined): boolean {
  if (selectedParentId === undefined) return true;
  const currentParentId = getParentTreeId(initialMoveNodeId);
  if (selectedParentId === null) return currentParentId === null;
  return selectedParentId === currentParentId;
}
